import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderRadius: 4,
  overflow: 'hidden',

  '& .TFNInfoContainer': {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0, 2),
  },
  '& .TFNInfoIcon': {
    fill: theme.palette.common.black,
  },
  '& .TFNTextContainer': {
    border: '1px solid',
    borderLeft: 'none',
    borderColor: theme.palette.divider[4],
    borderRadius: 4,
  },
}));
export default StyledBox;
